import React, {useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import sale1 from "../util/sale1.jpg"; // Import sale images
import sale2 from "../util/sale2.jpg";
import sale3 from "../util/sale3.jpg";
import sale4 from "../util/sale4.jpg";
import sale5 from "../util/sale5.jpg";
import infoImg from "../util/infoImg.jpg"; // Import image
import './work.css';
import ImageGallery from "./imageGallery";
import { text2015 } from "./galleryText";


const Work = () => {
  const [year, setYear] = useState(0);

  return (
    <div 
      className="work-container"
      style={{ 
        fontFamily: "Courier New",
        color: "black",
        padding: "5vh 5vw",  // Reduced padding
        maxWidth: "800px", // Prevent overly wide text
        textAlign: "left"
      }}
    >
      <div style={
        {
          height: "30px",
        }
      }/>
      Contact if intrested: gertruda.navidauskiene@gmail.com / @paisalioju
      <br />
      <br />
      <br />
      <br />
      <img 
                      src={sale1} 
                      alt="Info" 
                      style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        height: "auto", 
                        marginTop: "1rem" // Space after text
                      }} 
                    />
      Figūra 3 - <div style={{color:"red"}}>SOLD</div>
      <br />
      <br />
      <img 
                      src={sale2} 
                      alt="Info" 
                      style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        height: "auto", 
                        marginTop: "1rem" // Space after text
                      }} 
                    />
      Figūra 2 - <div style={{color:"red"}}>SOLD</div>
      <br />
      <br />
      <img 
                      src={sale3} 
                      alt="Info" 
                      style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        height: "auto", 
                        marginTop: "1rem" // Space after text
                      }} 
                    />
      Figūra 1 - <div style={{color:"red"}}>SOLD</div>
      <br />
      <br />
      <img 
                      src={sale4} 
                      alt="Info" 
                      style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        height: "auto", 
                        marginTop: "1rem" // Space after text
                      }} 
                    />
      Balionėliai - <div style={{color:"red"}}>SOLD</div>
      <br />
      <br />
      <img 
                      src={sale5} 
                      alt="Info" 
                      style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        height: "auto", 
                        marginTop: "1rem" // Space after text
                      }} 
                    />
      Aš esu veidas, vertas jūsų dėmesio - 300€
      <br />
      <br />
      <br />
      <br />
      Only few of my works are listed here, I have more.               
    </div>
  );
};

export default Work;

    /*{ year === 0 ?
    <p style={{ marginBottom: "1rem" }}>  
        <br />
        <br />
        <div className="selectYear" onClick={() => {setYear(2025)}}>2025</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2024)}}>2024</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2023)}}>2023</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2022)}}>2022</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2021)}}>2021</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2020)}}>2020</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2019)}}>2019</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2018)}}>2018</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2017)}}>2017</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2016)}}>2016</div>
        <br className="large-break"/>
        <br className="large-break"/>
        <div className="selectYear" onClick={() => {setYear(2015)}}>2015</div>

    </p> :
    <></>
    }
    { year === 2015 ? 
    <ImageGallery year={2015} imageCount={4} text={text2015} textPosition={[0]}/> : <></>}
    */